import { api, ApiError } from '@/lib/api';
import type { OwnerReview, PublicReview, VendorReview, ReviewPage, UpsertReviewInput } from './types';

// ---- Owner ----
export async function fetch_my_reviews(): Promise<OwnerReview[]> {
  const res = await api.get<OwnerReview[]>('/user/reviews');
  return res.data;
}

export async function fetch_my_review(booking_id: string): Promise<OwnerReview | null> {
  try {
    const res = await api.get<OwnerReview>(`/user/bookings/${booking_id}/review`);
    return res.data;
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }
}

export async function create_review(booking_id: string, input: UpsertReviewInput): Promise<OwnerReview> {
  const res = await api.post<OwnerReview>(`/user/bookings/${booking_id}/review`, input);
  return res.data;
}

export async function update_review(booking_id: string, input: UpsertReviewInput): Promise<OwnerReview> {
  const res = await api.patch<OwnerReview>(`/user/bookings/${booking_id}/review`, input);
  return res.data;
}

export async function delete_review(booking_id: string): Promise<void> {
  await api.delete(`/user/bookings/${booking_id}/review`);
}

export async function report_review(review_id: string, reason?: string): Promise<void> {
  await api.post(`/user/reviews/${review_id}/report`, reason ? { reason } : {});
}

// ---- Public ----
export async function fetch_public_reviews(vendor_id: string, page = 1): Promise<ReviewPage<PublicReview>> {
  const res = await api.get<ReviewPage<PublicReview>>(`/user/vendors/${vendor_id}/reviews`, { params: { page } });
  return res.data;
}

// ---- Vendor ----
export async function fetch_vendor_reviews(page = 1): Promise<ReviewPage<VendorReview>> {
  const res = await api.get<ReviewPage<VendorReview>>('/vendor/reviews', { params: { page } });
  return res.data;
}

export async function reply_to_review(review_id: string, reply: string): Promise<VendorReview> {
  const res = await api.post<VendorReview>(`/vendor/reviews/${review_id}/reply`, { reply });
  return res.data;
}
